import React, { useEffect, useState } from "react";
import { EditableTitle } from "../../../../../../components/src/editable-title/editable-title.component";
import { useJobStore } from "@/dentlab/src/store/Jobs";
import { useAutoSave } from "@/dentlab/src/hooks/useAutosave/useAutosave";

export const JobTitleForm: React.FC = () => {
	const { job, updateJob, setPendingChanges, pendingChanges } = useJobStore((state) => ({
		job: state.job,
		updateJob: state.updateJob,
		setPendingChanges: state.setPendingChanges,
		pendingChanges: state.pendingChanges,
	}));

	const [title, setTitle] = useState<string>("");

	useEffect(() => {
		setTitle(job?.title ?? "");
	}, [job]);

	const handleSubmit = async () => {
		if (title && job?.title !== title) {
			await updateJob("title", title, undefined, true);
			setPendingChanges(false);
		}
	};

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setTitle(e.target.value);
		if(!pendingChanges) {
			setPendingChanges(true);
		}
	};

	const handleReset = () => {
		setTitle(job?.title ?? "");
		setPendingChanges(false);
	};

	useAutoSave({
		data: title,
		onSave: handleSubmit,
		shouldSave: pendingChanges,
		delay: 500,
	});

	return (
		<>
			<EditableTitle
				name="title"
				value={title ?? ""}
				onChange={handleInputChange}
				onSubmit={handleSubmit}
				onReset={handleReset}
				autoSelect
			/>
		</>
	);
};
